import { render } from "./TermsAndConditions.vue?vue&type=template&id=a3132e0e&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=a3132e0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3132e0e"]])

export default __exports__